var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpherical(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.74 9.51C21.75 7.57 17.52 6 12 6S2.25 7.57.26 9.51a12.05 12.05 0 0 0 0 5C2.25 16.43 6.48 18 12 18s9.75-1.57 11.74-3.51a12.05 12.05 0 0 0 0-5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 4a23.3 23.3 0 0 1 10.54 2.26 12 12 0 0 0-21.08 0A23.3 23.3 0 0 1 12 4Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 20a23.3 23.3 0 0 1-10.54-2.26 12 12 0 0 0 21.08 0A23.3 23.3 0 0 1 12 20Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpherical);
export default __webpack_public_path__ + "static/media/spherical.53d574d566cf1ac82677db5c6f15be8c.svg";
export { ForwardRef as ReactComponent };